import { Link } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import Paper from "./Paper";
const PaperRow = ({ paper  }) => {
const {API}= useStateContext() ; 
const handleDownload = () => {
  fetch(`${API}${paper.Link}`)
      .then(response => response.blob()) 
      .then(blob => {
        alert(API + paper.Link)
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement('a');
          a.href = url;
          a.download = `${paper.Auther}_${paper.title}.pdf`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
      });
};
  return (
    <>
      <tr>
    
        <td>
           
              <h6 className="mb-0 text-sm">{paper.Auther  } </h6>
        </td>

        <td>
        <h6 className="mb-0 text-sm">{paper.title  } </h6>
        </td>
        <td>
        <button className="btn btn-danger" onClick={handleDownload}>Download</button>        </td>
        <td>
        <h6 className="mb-0 text-sm">{paper.status  } </h6>

        </td>
      
        <td className="align-middle">
          <Link className="btn btn-dark">
            View Paper
          </Link>
        </td>
      </tr>
    </>
  )
}

export default PaperRow; 